const LEVEL4_ACCOUNT_KEY = /^[34]\.\d+\.\d+\.\d+$/;

/** Solo mostramos sugerencias con cuenta de gasto (3) o ingreso (4) explícita. */
export function suggestionHasResolvableAccount(suggestion) {
  if (!suggestion) return false;
  const key = String(suggestion.suggestedAccountKey || '').trim();
  const name = String(suggestion.suggestedAccountName || '').trim();
  if (!key || !name) return false;
  if (!LEVEL4_ACCOUNT_KEY.test(key)) return false;
  const group = key.split('.')[0];
  if (suggestion.isReceived === true) return group === '3';
  if (suggestion.isReceived === false) return group === '4';
  return false;
}
